import { defineComponent as _defineComponent } from 'vue'
import { Servico } from 'common/types/Servico';
import { defineComponent } from 'vue';
import TextoComLinks from '@/components/TextoComLinks.vue';
import ContatoDoIrmao from '../irmao/ContatoDoIrmao.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogDetalhesDoServico',
  props: {
    servico: null
  },
  setup(__props: any) {

defineComponent({
    inheritAttrs: true,
})



return { __sfc: true,TextoComLinks, ContatoDoIrmao }
}

})